import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

firebase.initializeApp({
    apiKey: "AIzaSyCw7T_mufZJg6byGl04nPD4_Nx3GCHV8Pc",
    authDomain: "terraminds-9e273.firebaseapp.com",
    projectId: "terraminds-9e273",
    storageBucket: "terraminds-9e273.firebasestorage.app",
    messagingSenderId: "1049523509597",
    appId: "1:1049523509597:web:f579b34531d42e0db4f0b4",
    measurementId: "G-C1TCBJZK9P"
});


const fb = firebase;

export default fb;